import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { SezioneIncassi } from '../../../models/sezioni/sezione-incassi';
import { IncassiAddComponent } from './incassi-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: 'div [incasso-mod-add]',
  templateUrl: 'incasso-mod-add.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class IncassoModAdd {
  @Output() onReturn: EventEmitter<SezioneIncassi> = new EventEmitter<SezioneIncassi>();
  @ViewChild('formIncassoAdd') formIncasso: IncassiAddComponent;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();

  inizializza(idSezione: string, idFascicolo: string, idSezioneControparti: string, idSezioneEconomica: string, urlInsert: string, urlReadSezioneControparti: string, urlReadSezioneEconomica: string, urlUpdatePetitiumEconomico: string, fascicolo: FascicoloFull) {
    if (this.isPrd) this.formIncasso.inizializza(idSezione, idFascicolo, idSezioneControparti, urlInsert, urlReadSezioneControparti, fascicolo);
    openModal('modaladdIncasso');
  }

  createForm() {
    if (this.isPrd) this.formIncasso.createForm();
  }

  manageModal(sezioneIncassi: SezioneIncassi) {
    closeModal('modaladdIncasso');
    this.onReturn.emit(sezioneIncassi);
  }
}
